// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1rKf2","tab":"Tabs_tab__3xfFu","tabActive":"Tabs_tabActive__39cGV"};